import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import { PaginationLimit } from "../../Config";
import { useNavigate } from "react-router-dom";
import { FiToggleRight } from "react-icons/fi";
import {
    FaCheck,
} from "react-icons/fa";
import { capitalizeFirstLetter, getDueTypeLabel, truncateText } from "../../helpers";

const HiddenDuesTable = ({
    apiData,
    hideDueMutate,
    hideDueLoading,
    hideLoadingId,
    setHideLoadingId
}) => {
    const storageKey = `tenant_dues_hidden`;
    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);

    const navigate = useNavigate();
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [openActionMenu, setOpenActionMenu] = useState(null);

    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };

    const storageValue = sessionStorage.getItem(storageKey);
    const savedPage = storageValue !== null ? Number(storageValue) : 0;
    const [currentPage, setCurrentPage] = useState(savedPage);
    useEffect(() => {
        setCurrentPage(savedPage);
    }, [savedPage]);

    const showHideDue = (item) => {
        setHideLoadingId(item.id);
        hideDueMutate(
            {
                dueId: item.id,
                toggleValue: 0,
            },

        );
    };
    const ActionBtns = (item) => {
        const isLoading = hideLoadingId === item.id;

        return (
            <div className="flex gap-4">
                <button
                    type="button"
                    title="Click to unhide this due."
                    onClick={() => showHideDue(item)}
                    disabled={isLoading}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 focus:outline-none ${isLoading ? "bg-gray-400 cursor-not-allowed" : "bg-primary-color"}`}
                >
                    {isLoading ? (
                        <span className="absolute inset-0 flex items-center justify-center">
                            <span className="h-3 w-3 border-2 border-white border-t-transparent rounded-full animate-spin" />
                        </span>
                    ) : (
                        <span
                            className="inline-block h-4 w-4 transform rounded-full bg-white
              transition-transform duration-200 translate-x-6"
                        />
                    )}
                </button>
            </div>
        );
    };

    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                name: getName(item),
                type: getDuesType(item),
                dueDate: dueDate(item),
                amountBalance: getAmount(item),
                action: ActionBtns(item),
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu]);

    const getAmount = (item) => {
        return (
            <Amount>{'₹' + item.balance}</Amount>
        );
    };

    const getName = (item) => {
        const name = capitalizeFirstLetter(item?.tenantName);
        return (
            <UserImageWrapper
                onClick={() =>
                    navigate(`/tenantdetails/l/${item.tenantId}`, {
                        state: { data: item },
                    })
                }>
                <div className="flex-row flex">
                    <UserImage src={item.profilePicture ? item.profilePicture : Images.Avatar} alt={`Avatar for ${item.name}`} />
                    {(item.kycStatus === 5 || item.kycStatus === 4) &&
                        <div className="mt-auto rounded-full bg-green-500 h-4 w-4 flex items-center justify-center -ml-2.5">
                            <FaCheck className="text-white" size={10} />
                        </div>
                    }
                </div>
                <div className="flex flex-col gap-1">
                    <span className="text-gray-600 text-sm">
                        {truncateText(name, 25)}{""}
                    </span>
                    <span className="text-gray-400 text-xs">{item?.propertyName ? truncateText(item?.propertyName, 20) : 'N/A'}</span>
                </div>
            </UserImageWrapper>
        );
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const getDuesType = (item) => {
        let dueType = getDueTypeLabel(item.type);

        return (
            <div className='flex flex-col gap-0'>
                <span className="text-gray-600 text-sm">
                    {item.title ? item?.title?.toUpperCase() : dueType}
                </span>
                {(item.rentStartDate && item.rentEndDate) &&
                    <span className="text-gray-400 text-xs">{moment(item.rentStartDate).format('DD, MMM YY') + ' to ' + moment(item.rentEndDate).format('DD, MMM-YY')}</span>
                }
            </div>
        );
    };

    const dueDate = (item) => {
        return (
            <div className="flex flex-col text-sm text-gray-600">
                <span>
                    {item.dueDate ? moment(item.dueDate).format("DD, MMM YY") : "---"}
                </span>
            </div>
        );
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {
            return [
                {
                    Header: "Tenant",
                    accessor: "name",
                },

                {
                    Header: "Balance",
                    accessor: "amountBalance",
                },
            ];
        }
        return [
            {
                Header: "Tenant",
                accessor: "name",
            },
            {
                Header: "Balance",
                accessor: "amountBalance",
            },
            {
                Header: "For",
                accessor: "type",
            },
            {
                Header: "Date",
                accessor: "dueDate",
            },

            {
                Header: "",
                accessor: "action",
            },
        ];
    }, [isMobileView]);
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex },
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        sessionStorage.setItem(storageKey, pageIndex);
    }, [pageIndex, storageKey]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);

                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}
                                >
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {typeof cell.value === "function"
                                                    ? cell.value()  // render dynamic function
                                                    : cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2 ">
                                                <li>
                                                    <strong>Due</strong> {data[rowIndex].type}
                                                </li>
                                                <li>
                                                    <strong>Due Date</strong> {data[rowIndex].dueDate}
                                                </li>
                                                <li>
                                                    <strong>Action:</strong> {data[rowIndex].action}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}


        </>
    );
};

const UserImageWrapper = tw.div` flex items-center gap-2 cursor-pointer`;
const UserImage = tw.img`w-9 h-9 rounded-full `;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Amount = tw.p`
  text-rose-600 font-semibold
  bg-rose-50 px-3 py-1
  rounded-full inline-flex
  cursor-pointer
`;

export default HiddenDuesTable;
